import { defineStyle as o, defineStyleConfig as n } from "@chakra-ui/styled-system";
const i = o({}), c = {
  xl: o({
    w: "icon.xl",
    h: "icon.xl"
  }),
  lg: o({
    w: "icon.lg",
    h: "icon.lg"
  }),
  md: o({
    w: "icon.md",
    h: "icon.md"
  }),
  sm: o({
    w: "icon.sm",
    h: "icon.sm"
  })
}, l = n({
  baseStyle: i,
  sizes: c
});
export {
  l as iconTheme
};
